import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },
  headerTitleBox: {
    width: '100%',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& h5': {
      fontWeight: '600',
      fontSize: '1.25rem',
      color: theme.palette.blue_300.main
    },
    '& .MuiTypography-gutterBottom': {
      marginBottom: 0
    }
  },
  headerTutorial: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& span': {
      fontWeight: '600',
      fontSize: '1rem'
    },
    '& button': {
      color: theme.palette.blue_100.main,
      '& span': {
        display: 'flex',
        gap: '4px'
      }
    },
    '& button:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent'
    }
  },
  headerDescription: {
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px'
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 8px',
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  tableHeader: {
    color: theme.palette.blue_300.main,
    fontWeight: '600',
    fontSize: '1rem'
  },
  tableCellTitle: {
    fontWeight: '600',
    fontSize: '1rem',
    color: theme.palette.blue_300.main,
    borderBottom: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`
  },
  tableCellMessage: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    borderBottom: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`
  },
  tableRowEven: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.blue_50.main
  },
  tableRowOdd: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
  },
  buttonActionEdit: {
    padding: '6px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  buttonActionDelete: {
    padding: '6px',
    borderRadius: 8,
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },

  boxForms: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    padding: '4px 20px'
  }
}))
